import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SrcPath } from'src/app/constants/srcPath';
import { ToastrService } from 'ngx-toastr';
import { Labels } from'src/app/constants/labels';
import { isBlank, isData, iconListOptions, booleanOptions, isPresent, getStaticNumbers } from 'src/app/utils/utils';
import { ColumnHeader } from 'src/app/models/column-header';
import { CommonModule, Location } from '@angular/common';
import { KEYS } from'src/app/constants/keys';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-create-menu',
  templateUrl: './create-menu.component.html',
  styleUrls: ['./create-menu.component.scss'],
  imports:[CommonModule,NgSelectComponent,FormsModule,ReactiveFormsModule,SharedModule]
})
export class CreateMenuComponent implements OnInit {
  menuForm: FormGroup |any;
  headerData: ColumnHeader |any;
  parent_menu_id: any = 0;
  type_of_menu: any = 0;
  ispagelinked: any = 0;
  public appPageList: any = [];
  menuIcons = iconListOptions;
  pageId: any = "";
  srcPath = SrcPath;
  labelMessages = Labels.messages;
  labelName = Labels.labels;
  submitted = false;
  public icon_link1 = this.srcPath.menuIconPath + this.labelName.default_icon;
  icon_link: any = this.srcPath.menuIconPath + this.labelName.default_icon;
  isSuperaDmin: boolean = false;
  dbPath: any;
  menuListdata: any = [];
  booleanOptions = booleanOptions;
  isDynamicPage: any = 'true';
  isParentModule: any;
  staticPageslist: any = [];
  staticorderlist: any;
  showDivParent: boolean = false;
  Isshowin_dynamicMdoule: any;
  menumoduleorderData: any = [];
  dynamicorderlist: any;
  parentmeny_DynId: any;
  parenst_menuId: any;
  isSubmenu: any = 0;
  parentMenus: any = [];
  subMenuList: any = [];
  parent_menuId: any;
  messageLabel = Labels.messages;
  constructor(public httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private toastr: ToastrService, private formBuilder: FormBuilder,
    private _location: Location, private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.commonService.ogLog('create menu')

    this.loadOrderMenuData(0);
    this.loadStaticMenu();
    this.isSuperAdmin();
    this.initColumnHeader();
    this.fillAppPageList();
    this.initPageForm();
    this.LoadAllMenu();
    if (isPresent(sessionStorage.getItem(KEYS.static_menus)) && this.staticPageslist.length == 0) {
      this.staticPageslist = JSON.parse(sessionStorage.getItem(KEYS.StaticallMenuList)!);
      this.staticorderlist = getStaticNumbers(this.staticPageslist.length);
    }
    if (isPresent(sessionStorage.getItem(KEYS.OrderMenuList) && this.menumoduleorderData.length == 0)) {
      this.menumoduleorderData = JSON.parse(sessionStorage.getItem(KEYS.OrderMenuList)!);
    }


  }
  loadFillData() {
    this.commonService.ogLog('menuListdata1', this.parentMenus);

    this.route.queryParams.subscribe(params => {
      const id = params['menu_id'];
      if (id > 0) {
        const menuDetails = params['menuDetails'];
        this.commonService.ogLog('menuDetails 48 :', JSON.parse(menuDetails));
        this.loadMenu(JSON.parse(menuDetails));
      }
      else {
        this.initPageForm();
      }
    });
  }
  isSuperAdmin() {
     const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initColumnHeader() {
    this.headerData = {
      title: Labels.menu.title,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: Labels.menu.save_title,
            icon: SrcPath.saveIcon,
            class: Labels.menu.save_class
          },
          {
            title: Labels.menu.back_menu,
            icon: SrcPath.previousIcon,
            class: Labels.menu.class
          }
        ]
      }
    };
  }

  initPageForm() {
    this.submitted = false;
    this.route.queryParams.subscribe(params => {
      this.commonService.ogLog("Params:", params);
      this.menuForm = this.formBuilder.group({
        menuId: 0,
        menuName: ['', Validators.required],
        menuIcon: [this.labelName.default_icon, Validators.required],
        ispagelinked: [0],
        pageId: [null],
        menuType: (params['menu_type'] == null ? KEYS.actionType.add : params['menu_type']),
        parentMenuId: (params['parent_menu_id'] == null ? '0' : params['parent_menu_id']),
        isWithChildMenues: [KEYS.checkedStatus.unchecked],
        isWithChildInnerPage: [KEYS.checkedStatus.unchecked],
        isDynamicmenu: ['true'],
        showunder_Dynamicmenu: ['false'],
        show_ParentModule: ['false'],
        ParentModule: [],
        lstorder: [],
        ParentStMenuId: [],
        parentdynMenuId: [],
        menuorderId: 0,
        isSubmenu: [0],
        subMenuPageId: [null],
        isHide: ['false']
      });
    });
  }
  loadMenu(menuDetails:any) {
    this.commonService.ogLog("Menu Details:", menuDetails);
    let parentmenus:any = [];
    let parentid;
    let dynamiOr_Static = '';
    if (isPresent(menuDetails[0]['gstibo_menu_listing_order']) && menuDetails[0]['gstibo_menu_listing_order'] > 0) {
      dynamiOr_Static = 'S';
      parentmenus = this.staticPageslist.filter((x:any) => x.gstibo_is_show_parentmodule_Id == 0);
      let data = parentmenus.filter((g:any) => g.gstibo_page_id == menuDetails[0]['gstibo_is_show_parentmodule_Id']);
      if (data.length == 0) {
        data = this.menuListdata.filter((g:any) => g.gstibo_menu_id == menuDetails[0]['gstibo_is_show_parentmodule_Id']);
        if (isPresent(data)) {
          parentid = Number(data[0]['gstibo_menu_id']);
        }
      }
      else {
        parentid = Number(data[0]['gstibo_page_id']);
      }
      this.showDivParent = true;
    }
    if (menuDetails[0]['pagetype'] == 'S') {
      dynamiOr_Static = 'S';
      this.showDivParent = true;
    }
    else if (dynamiOr_Static == '') {
      dynamiOr_Static = 'D';
    }
    this.ispagelinked = (menuDetails[0]['gstibo_page_id'] == 0 ? 0 : 1);
    this.isSubmenu = (menuDetails[0]['gstibo_page_parent_id'] == null || menuDetails[0]['gstibo_page_parent_id'] == 0 ? 0 : 1);
    
    let menumoduleorderid;
    if (isPresent(this.menumoduleorderData)) {
      if (dynamiOr_Static == 'D') {
        let data = this.menumoduleorderData.filter((g:any) => g.gstibo_menu_id == menuDetails[0]['gstibo_menu_id'] && g.gstibo_isdynamic == 'D');
        if (isPresent(data)) {
          menumoduleorderid = data[0]['gstibo_menu_listing_order']
        }
      }
    }

    this.commonService.ogLog("menuDetails[0]['gstibo_with_child_menues']", menuDetails[0]['gstibo_with_child_menues']);
    this.commonService.ogLog("menuDetails[0]['gstibo_with_child_inner_page']", menuDetails[0]['gstibo_with_child_inner_page']);
    this.menuForm = this.formBuilder.group({
      menuId: menuDetails[0]['gstibo_menu_id'],
      menuName: [menuDetails[0]['gstibo_menu_name'], Validators.required],
      menuIcon: [(menuDetails[0]['gstibo_menu_icon'] == null ? menuDetails[0]['gstibo_icon'] : menuDetails[0]['gstibo_menu_icon'])],
      ispagelinked: this.ispagelinked,
      pageId: [(menuDetails[0]['gstibo_page_id'] == null ? menuDetails[0]['gstibo_menu_id'] : menuDetails[0]['gstibo_page_id'])],
      menuType: [(menuDetails[0]['gstibo_menu_type'] == null ? 2 : menuDetails[0]['gstibo_menu_type'])],
      parentMenuId: [menuDetails[0]['gstibo_parent_menu_id'] == 0 ? parentid : Number(menuDetails[0]['gstibo_parent_menu_id'])],
      isWithChildMenues: [((menuDetails[0]['gstibo_with_child_menues']) == 1 ? true : false)],
      isWithChildInnerPage: [((menuDetails[0]['gstibo_with_child_inner_page']) == 1 ? true : false)],
      isDynamicmenu: [(dynamiOr_Static == 'S' ? 'false' : 'true')],
      showunder_Dynamicmenu: [((menuDetails[0]['gstibo_is_show_in_dynamic_menu'] == 'N' || menuDetails[0]['gstibo_is_show_in_dynamic_menu'] == null) ? 'false' : 'true')],
      show_ParentModule: [((menuDetails[0]['gstibo_is_show_parentmodule'] == 'N' || !isPresent(menuDetails[0]['gstibo_is_show_parentmodule'])) ? 'false' : 'true')],
      ParentModule: [Number(menuDetails[0]['gstibo_is_show_parentmodule_Id'])],
      lstorder: [menuDetails[0]['gstibo_listing_order']],
      menuorderId: (isPresent(menumoduleorderid) ? menumoduleorderid : menuDetails[0]['gstibo_listing_order']),
      ParentStMenuId: [Number(menuDetails[0]['gstibo_is_show_parentmodule_Id'])],
      parentdynMenuId: [Number(menuDetails[0]['gstibo_is_show_parentmodule_Id'])],
      isSubmenu: this.isSubmenu,
      subMenuPageId: [Number(menuDetails[0]['gstibo_page_parent_id'])],
      isHide: [(menuDetails[0]['gstibo_is_hide']) == 1 ? 'true': 'false'],
    });
    this.parent_menuId = (menuDetails[0]['gstibo_parent_menu_id']);
    this.fillSubmenuPage(this.parent_menuId);
    this.isDynamicPage = (this.showDivParent == false ? 'true' : this.menuForm.value.isDynamicmenu);
    this.isParentModule = this.menuForm.value.show_ParentModule;
    this.Isshowin_dynamicMdoule = this.menuForm.value.showunder_Dynamicmenu;
    this.commonService.ogLog(' this.menuForm', this.menuForm);

  }
  fillAppPageList() {
    this.appPageList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data :any)=> {
      if (isData(data)) {
        data['table'].forEach((element:any) => {
          this.appPageList.push({
            'pageId': element.gstibo_page_id,
            'pageName': element.gstibo_page_name
          });
        });
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
  }

  onSubmit() {
    this.submitted = true;
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.ogLog("Save:", this.menuForm.value);
    this.commonService.ogLog("Save:", this);
    this.commonService.ogLog("Save:", this.parent_menu_id); 
    this.menuForm.value.pageId = this.menuForm.value.pageId == null ? 0 : this.menuForm.value.pageId;
    if (!(isBlank(this.menuForm.value.menuName)) && !(isBlank(this.menuForm.value.menuIcon))
      && (this.menuForm.value.ispagelinked == 0 || (this.menuForm.value.ispagelinked == "1" && this.menuForm.value.pageId != '0'))) {
      if (this.menuForm.valid) {
        if (this.menuForm.value.menuId <= 0) {
          this.commonService.ogLog('dynamicvalue', this.menuForm.value);
          if (this.menuForm.value.isDynamicmenu == 'true') {
            if (this.menuForm.value.parentMenuId == null) {
              this.menuForm.value.parentMenuId = this.parent_menu_id
            }
            this.commonService.setMenuOrderId(this.menuForm.value.menuorderId)
            if (isBlank(this.menuForm.value.subMenuPageId)){
              this.menuForm.value.menuorderId = 0;
            }
            let listingOrder =  this.commonService.getMenuOrderId();
            this.menuForm.value.subMenuPageId =  this.menuForm.value.isSubmenu == 1 ?  this.menuForm.value.subMenuPageId : 0;
            this.commonService.createMenu(dbFullPath, this.menuForm.value, this.commonService.getUserCredentials(KEYS.credential_account_id), listingOrder).subscribe((data :any)=> {
              //this.toastr.success(this.labelMessages.save_success_msg.message);
               this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
              let menuid = data['table'][0]['gstibo_menu_id'];
              let existCheck =data['table'][0]['existId'];
              this.commonService.ogLog('menuid', menuid);
              let menuOrderId = this.commonService.getMenuOrderId();
              if(menuid >0)
              {
                this.commonService.add_Update_MenuOrderList(menuid, this.menuForm.value.parentMenuId, menuOrderId,
                  this.menuForm.value.parentMenuId, 'D', 'Y', this.menuForm.value.isHide,existCheck).subscribe((data :any)=> {
                  });
              }
             
            },
              error => {
                console.log('createMenu Error:', error);
              });
          }
          else if (this.menuForm.value.isDynamicmenu == 'false') {
            if (this.menuForm.value.showunder_Dynamicmenu == 'true') {
              if (this.parentmeny_DynId < 0) {
                this.menuForm.value.ParentModule = this.menuForm.value.parentdynMenuId;
                this.parentmeny_DynId = this.menuForm.value.parentdynMenuId;
              }
              else {
                this.menuForm.value.ParentModule = this.parentmeny_DynId;
              }
            }
            else { 
              this.menuForm.value.ParentModule =this.menuForm.value.parentMenuId;
              if(isBlank(this.menuForm.value.lstorder))             
              {
                this.menuForm.value.lstorder =[Number(this.menuForm.value.menuorderId)];
              }
            }
            this.commonService.ogLog('logmenuform2', this.menuForm.value, this.parentmeny_DynId);
            this.commonService.AddUpdateStaticpages(this.menuForm.value, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((data :any)=> {
              //this.toastr.success(this.labelMessages.save_success_msg.message);
               this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
              if (this.menuForm.value.showunder_Dynamicmenu == 'true') {
                let menuid = data['table'][0]['gstibo_page_id'];
                let existCheck =2;//data['table'][0]['existId'];
                this.commonService.ogLog('menuid', menuid);
                this.commonService.ogLog('logmenuform', this.menuForm.value);
                if (menuid > 0) {
                  this.commonService.add_Update_MenuOrderList(menuid, menuid, this.menuForm.value.lstorder,
                    this.parentmeny_DynId, 'S', 'Y', this.menuForm.value.isHide,existCheck).subscribe((data :any)=> {
                    });
                }
               
              }
            },
              error => {
                console.log('createMenu Error:', error);
              });
          }

        } else {
          this.commonService.ogLog('dynamicvalueUpdate', this.menuForm.value.isDynamicmenu);
          if (this.menuForm.value.isDynamicmenu == 'true') {
            if (this.menuForm.value.ispagelinked == '0')
              this.menuForm.value.pageId = '0';
            this.commonService.ogLog("Menu Form:", this.menuForm.value.subMenuPageId);
            this.menuForm.value.subMenuPageId =  this.menuForm.value.isSubmenu == 1 ?  this.menuForm.value.subMenuPageId : 0;
            this.commonService.setMenuOrderId(this.menuForm.value.menuorderId)
            if (this.menuForm.value.subMenuPageId == 0){
              this.menuForm.value.menuorderId = 0;
            }
            let listingOrder =  this.commonService.getMenuOrderId();
            this.commonService.updateMenu(dbFullPath, this.menuForm.value, this.commonService.getUserCredentials(KEYS.credential_account_id), listingOrder).subscribe((data :any)=> {
             // this.toastr.success(this.labelMessages.update_success_msg.message);
              this.commonService.showModalValidate(this.labelMessages.update_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.update_success_msg.message);
              let menuOrderId = this.commonService.getMenuOrderId();
              this.commonService.add_Update_MenuOrderList(this.menuForm.value.menuId, this.menuForm.value.parentMenuId, menuOrderId,
                this.menuForm.value.parentMenuId, 'D', 'Y', this.menuForm.value.isHide,1).subscribe((data :any)=> {
                });
            },
              error => {
                console.log('updateMenu Error:', error);
              });
          }
          else if (this.menuForm.value.isDynamicmenu == 'false') {
            if (this.menuForm.value.showunder_Dynamicmenu == 'true') {
              if (this.parentmeny_DynId < 0) {
                this.menuForm.value.ParentModule = this.menuForm.value.parentdynMenuId;
                this.parentmeny_DynId = this.menuForm.value.parentdynMenuId;
              }
              else {
                if(isBlank(this.menuForm.value.ParentModule))
                this.menuForm.value.ParentModule =[Number(this.parentmeny_DynId)]; 
                if(isBlank(this.menuForm.value.lstorder))             
                  {
                    this.menuForm.value.lstorder =[Number(this.menuForm.value.menuorderId)];
                  } 
              }
            }
            else {
              if(isBlank(this.menuForm.value.ParentModule))
                this.menuForm.value.ParentModule = [Number(this.menuForm.value.ParentStMenuId)];
              if (isPresent(this.menuForm.value.ParentStMenuId)) {
                this.menuForm.value.ParentModule = [Number(this.menuForm.value.ParentStMenuId)];
              }
              if(isBlank(this.menuForm.value.lstorder))             
                {
                  this.menuForm.value.lstorder =[Number(this.menuForm.value.menuorderId)];
                } 
            }
            this.commonService.AddUpdateStaticpages(this.menuForm.value, this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe((data :any)=> {
              //this.toastr.success(this.labelMessages.save_success_msg.message);
               this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
              this.commonService.add_Update_MenuOrderList(this.menuForm.value.menuId, this.menuForm.value.parentMenuId, this.menuForm.value.lstorder,
                this.menuForm.value.parentMenuId, 'S', 'Y', this.menuForm.value.isHide,2).subscribe((data :any)=> {
                });
            },
              error => {
                console.log('createMenu Error:', error);
              });
          }
        }
      }
    }
    else {
      if (this.menuForm.value.ispagelinked == "1" && this.menuForm.value.pageId == null) {
       // this.toastr.warning(this.labelMessages.common_required_msg.message + 'linked page');
        this.commonService.showModalValidate(this.labelMessages.common_required_msg.message + 'linked page','',this.messageLabel.static_messages.warning,this.labelMessages.common_required_msg.message + 'linked page');
      }
      if (isBlank(this.menuForm.value.menuIcon)) {
       // this.toastr.warning(this.labelMessages.common_required_msg.message + 'menu icon');
        this.commonService.showModalValidate(this.labelMessages.common_required_msg.message + 'menu icon','',this.messageLabel.static_messages.warning,this.labelMessages.common_required_msg.message + 'menu icon');
      }
      if (isBlank(this.menuForm.value.menuName)) {
       // this.toastr.warning(this.labelMessages.common_required_msg.message + 'menu name');
        this.commonService.showModalValidate(this.labelMessages.common_required_msg.message + 'menu name','',this.messageLabel.static_messages.warning,this.labelMessages.common_required_msg.message + 'menu name');
      }
    }

  }

  get f() { return this.menuForm.controls; }
  // gotoparent() {
  //   this.router.navigate(['../'], { relativeTo: this.activeRoute.parent });
  // }
  LoadAllMenu() {
    // this.menuListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenuforAdmin(dbFullPath, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data :any)=> {
      if (isData(data)) {
        this.menuListdata = data['table'].filter((x:any) => x.gstibo_parent_menu_id == 0);
        this.parentMenus = this.menuListdata;
        const parentmenus = this.staticPageslist.filter((x:any) => x.gstibo_is_show_parentmodule_Id == 0);
        parentmenus.forEach((element:any) => {
          this.menuListdata.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'moduleid': element.gstibo_menu_id,
              'gstibo_menu_icon': 'timesheet',
              'pgid': element.gstibo_page_id,
              'child': data['table'].filter((x:any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0),
              'pagetype': 'S'
            });

        });
        // if(this.menuListdata.length >0)
        // {
        //   this.dynamicorderlist = getStaticNumbers(this.menuListdata.child.length); 
        // }
        this.loadFillData();
      }

      (error:any) => {
        console.log('executeLogicAppsApi Error:', error);
      }
    });
  }
  dynamic_Change(e:any) {
    this.isDynamicPage = e.name;
  }
  Isparent_Change(e:any) {
    this.isParentModule = e.name;
  }
  Isdynamic_Change(e:any) {
    this.Isshowin_dynamicMdoule = e.name;
  }
  loadOrderMenuData(menuid:any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data :any)=> {
      if (isData(data)) {
        // if(this.menumoduleorderData.length ==0)
        // {
        this.menumoduleorderData = data['table'];
        // }
      }
    });
  }
  loadStaticMenu() {

    let userAccountID = this.commonService.getUserCredentials(KEYS.credential_customer_id);
    this.commonService.loadStaticMenuForUser(userAccountID).subscribe((data :any)=> {
      if (isData(data)) {
        this.staticPageslist = [];
        this.staticPageslist = data['table'];
      }
    });
  }
  IparentdynMenu_Change(e:any) {
    this.commonService.ogLog('idparent', e)
    this.parentmeny_DynId = e.moduleid;
  }
  IparentstMenu_Change(e:any) {
    this.commonService.ogLog('idparent', e)
    this.parenst_menuId = e.moduleid;
  }
  module_Change(e:any) {
    this.parent_menuId = ''
    this.commonService.ogLog('idparent', e)
    this.parent_menu_id = e.moduleid;
    this.parent_menuId = e.gstibo_menu_id
    this.fillSubmenuPage(this.parent_menuId);
  }
  fillSubmenuPage(parent_menuId:any) {
    this.commonService.ogLog(parent_menuId);
    let menuItem:any;
    let subMenu = []
    let tempArray = []
    menuItem = localStorage.getItem('menuItems')
    subMenu = JSON.parse(menuItem)
    tempArray = subMenu.filter((item:any ) => item.id == parent_menuId)
    this.subMenuList = [];
    tempArray.forEach((element:any ) => {
      this.commonService.ogLog(element);
      element.submenu.forEach((el:any) => {
        this.subMenuList.push({
          'pageId': el.menuId,
          'pageName': el.name
        });
      });
    });
    this.commonService.ogLog( this.subMenuList);
    
  }
}
